export const chickenAndMethiFruit = {
  id: "chickenAndMethiFruit",
  link: "/#/recipes/recipes/chickenAndMethiFruit",
  name: "Chicken and Methi Fruit",
  cuisine: "Alethi",
  summary: "Pan fried chicken served with a sweet and savory persimmon sauce",
  inspiration: null,
  quantity: "4 servings",
  time: "45 minutes",
  notes:
    "There's not much to say about this one. The book described chicken with steamed fruit and sauce, so that's what I made, and it was delicious. Make sure to use fuya persimmons and not hachiya or american persimmons. For a complete meal, I recommend serving with some sort of starch, such as rice.",
  quotes:
    "It appeared to also have been made with the exotic chicken, but had been mixed with steamed methi fruit and covered in a reddish-brown sauce. (The Way of Kings ch 22)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/chicken-and-methi-fruit-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "chicken",
          display: "2 medium chicken breasts"
        },
        {
          item: "coconut",
          display: "2 tbsp coconut oil, divided"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "lemon",
          display: "1 tbsp plus 2 tsp lemon juice, divided"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "chicken",
          display: "1 14.45 oz can chicken stock"
        },
        {
          item: "ginger",
          display: "2 inches ginger"
        },
        {
          item: "molasses",
          display: "1 tbsp molasses"
        },
        {
          item: "oysterSauce",
          display: "1 tbsp oyster sauce"
        },
        {
          item: "persimmons",
          display: "2 cups chopped firm fuya persimmons (about 4 small persimmons, or 3 large)"
        },
        {
          item: "corn",
          display: "1 tbsp corn starch"
        },
        {
          item: "water",
          display: "1/4 cup cold water"
        }
      ]
    }
  ],
  steps: [
    "Slice the chicken breasts along the sides to get slabs the same shape as the original breasts, but 1/2 inch thick.",
    "Heat 1 tbsp coconut oil in a large stainless steel skillet over medium high heat. Place chicken in a single layer in the pan. Sprinkle with cumin, salt, and 1 tbsp lemon juice. Cook until the bottom of the chicken browns a bit and releases from the pan. Flip and continue to cook until cooked through and both sides are somewhat browned.",
    "Remove the chicken from the pan, put on a plate, and cover with foil to keep warm. Dice the onion and add it to the pan along with 1 tbsp coconut oil. Cook over medium heat until tender.",
    "Add the chicken stock to the pan and stir to deglaze any remaining brown bits stuck to the pan. Peel and mince the ginger. Add the ginger to the pan along with the molasses, oyster sauce, and 2 tsp lemon juice. Bring to a boil, then reduce heat and simmer for 5 minutes.",
    "Peel and chop the persimmons to 1/2 inch cubes. Discard the white bits at the center and the stems. Add the persimmons to the pan and stir. Cover and simmer for 5 minutes until the persimmons are tender.",
    "In a small bowl, combine the corn starch and cold water. Add it to the pan and stir until the sauce thickens. Slice the chicken and serve the persimmon sauce over the chicken."
  ]
}
